export default {"src":"/_next/static/media/light.9cfd9204.svg","height":35,"width":144,"blurWidth":0,"blurHeight":0};